import axios from "axios";

export default async function post(body, url) {
    var uri = process.env.REACT_APP_ASSET_BASE_URL + '/' + url;
    var headers = {"Content-Type": "application/json"};
    var response = await axios.post(uri, body, { headers });
    return response;
}